var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:{ checked: _vm.value },on:{"click":_vm.onClickCheckbox}},[(_vm.value)?_c('i',{staticClass:"material-icons"},[_vm._v("check")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }